export class TableRow {
  public id: string; // Always present, unique
  public DISTransactionId?: string | null; // For new/unsaved rows
  public initialValue?: any;
  public currentValue?: any;
  public rowState: number;
}
